import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import _ from 'lodash';
import axios from 'axios';
import {
  HistoricoRespostaFormData,
  PacienteFormExterno,
  PacienteFormExternoEtapa1,
  PacienteFormExternoEtapa2,
  PacienteFormExternoEtapa3,
  PacienteFormExternoEtapa4,
  UsuarioAuth,
  PacienteAba,
} from '../../../back/src/types';

Vue.use(Vuex);
export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    historicoRespostaFormData: [] as HistoricoRespostaFormData[],
    pacienteFormExterno: {} as PacienteFormExterno,
    usuario: {} as UsuarioAuth,
    pacientesAbas: [] as PacienteAba[],
    permissoes: {} as Object,
    previousRoute: null,
  },
  getters: {
    historicoRespostaFormData: state => state.historicoRespostaFormData,
    pacienteFormExternoEtapa1: (state) => {
      if (_.has(state.pacienteFormExterno, 'Etapa1')) {
        return state.pacienteFormExterno.Etapa1;
      }
      return {} as PacienteFormExternoEtapa1;
    },
    pacienteFormExternoEtapa2: (state) => {
      if (_.has(state.pacienteFormExterno, 'Etapa2')) {
        return state.pacienteFormExterno.Etapa2;
      }
      return {} as PacienteFormExternoEtapa2;
    },
    pacienteFormExternoEtapa3: (state) => {
      if (_.has(state.pacienteFormExterno, 'Etapa3')) {
        return state.pacienteFormExterno.Etapa3;
      }
      return {} as PacienteFormExternoEtapa3;
    },
    pacienteFormExternoEtapa4: (state) => {
      if (_.has(state.pacienteFormExterno, 'Etapa4')) {
        return state.pacienteFormExterno.Etapa4;
      }
      return {} as PacienteFormExternoEtapa4;
    },
    usuario: state => state.usuario,
    token: (state) => {
      if (_.has(state.usuario, 'token')) {
        return state.usuario.token;
      }
      return '';
    },
    pacientesAbas: state => (pacienteId: number) => _.find(
      state.pacientesAbas,
      el => el.paciente_id === pacienteId,
    ) || null,
    permissoes: state => state.permissoes,
    previousRoute: state => state.previousRoute,
  },
  mutations: {
    pullHistoricoRespostaFormData(state, historicoRespostaId: number) {
      _.remove(
        state.historicoRespostaFormData as HistoricoRespostaFormData[],
        el => (el.id === historicoRespostaId),
      );
    },
    pushHistoricoRespostaFormData(state, formData: HistoricoRespostaFormData) {
      const index = _.findIndex(
        state.historicoRespostaFormData as HistoricoRespostaFormData[],
        el => (el.id === formData.id),
      );
      if (index >= 0) {
        state.historicoRespostaFormData[index] = formData;
      } else {
        state.historicoRespostaFormData.push(formData);
      }
    },
    setHistoricoRespostaFormData(state, formData: HistoricoRespostaFormData[]) {
      state.historicoRespostaFormData = formData;
    },
    setPacienteFormExterno(state, form: PacienteFormExterno) {
      state.pacienteFormExterno = form;
    },
    setPacienteFormExternoEtapa1(state, form: PacienteFormExternoEtapa1) {
      state.pacienteFormExterno.Etapa1 = form;
    },
    setPacienteFormExternoEtapa2(state, form: PacienteFormExternoEtapa2) {
      state.pacienteFormExterno.Etapa2 = form;
    },
    setPacienteFormExternoEtapa3(state, form: PacienteFormExternoEtapa3) {
      state.pacienteFormExterno.Etapa3 = form;
    },
    setPacienteFormExternoEtapa4(state, form: PacienteFormExternoEtapa4) {
      state.pacienteFormExterno.Etapa4 = form;
    },
    setUsuario(state, usuario: UsuarioAuth) {
      state.usuario = usuario;
    },
    setPermissoes(state, permissoes) {
      state.permissoes = permissoes;
    },
    addPacienteAba(state, item: PacienteAba) {
      const index = _.findIndex(
        state.pacientesAbas as PacienteAba[],
        el => (el.paciente_id === item.paciente_id),
      );
      if (index >= 0) {
        state.pacientesAbas[index] = item;
      } else {
        state.pacientesAbas.push(item);
      }
    },
    emptyPacientesAba(state) {
      state.pacientesAbas = [] as PacienteAba[];
    },
    previousRouteSetter(state, previousRoute) {
      state.previousRoute = previousRoute;
    },
  },
  actions: {
    // USUÁRIOS
    login(context, usuario: UsuarioAuth): void {
      // Auth header no momento do login
      axios.defaults.headers.common.Authorization = `Bearer ${usuario.token}`;
      context.commit('setUsuario', usuario);
      context.commit('setHistoricoRespostaFormData', [] as HistoricoRespostaFormData[]);
      context.commit('setPacienteFormExterno', {} as PacienteFormExterno);
      context.commit('setPermissoes', usuario.permissoes);
    },
    logout(context): void {
      axios.defaults.headers.common.Authorization = 'Bearer ';
      context.commit('setUsuario', {} as UsuarioAuth);
      context.commit('emptyPacientesAba');
    },
    // PACIENTES
    resetPacienteFormExterno(context): void {
      context.commit('setPacienteFormExterno', {} as PacienteFormExterno);
    },
    updatePacienteFormExternoEtapa1(context, form: PacienteFormExternoEtapa1): void {
      context.commit('setPacienteFormExternoEtapa1', form);
    },
    updatePacienteFormExternoEtapa2(context, form: PacienteFormExternoEtapa2): void {
      context.commit('setPacienteFormExternoEtapa2', form);
    },
    updatePacienteFormExternoEtapa3(context, form: PacienteFormExternoEtapa3): void {
      context.commit('setPacienteFormExternoEtapa3', form);
    },
    updatePacienteFormExternoEtapa4(context, form: PacienteFormExternoEtapa4): void {
      context.commit('setPacienteFormExternoEtapa4', form);
    },
    // HISTORICOS
    pullHistoricoRespostaFormData(context, historicoRespostaId: number): void {
      context.commit('pullHistoricoRespostaFormData', historicoRespostaId);
    },
    pushHistoricoRespostaFormData(context, formData: HistoricoRespostaFormData): void {
      context.commit('pushHistoricoRespostaFormData', formData);
    },
    // PACIENTES E ABAS
    pushPacienteAba(context, item: PacienteAba) {
      context.commit('addPacienteAba', item);
    },
    // ROTA ANTERIOR
    setPreviousRoute(context, previousRoute) {
      context.commit('previousRouteSetter', previousRoute);
    },
  },
  modules: {
  },
});
